import { error, finish } from '../../../modules/markets/actions/update-dividend';
import api from '../../../api';

export function request(dispatch, { eventId, marketId, dividendId, dividendType, data }) {
    api.put(`/events/${eventId}/markets/${marketId}/dividends/${dividendType}/${dividendId}`, data)
        .then(
            market => {
                market.selections = Object.keys(market.selections).map(x => market.selections[x]);

                dispatch(finish(marketId, dividendId, market));
            },
            errors => dispatch(error(marketId, dividendId, errors))
        );
}
